import s from './Main.module.scss'
import React, { lazy, Suspense, useRef } from 'react'
import { PageContent } from 'shared/components/PageContent'
import { useRevealOnScroll } from 'shared/hooks'
import { Banner } from './Banner'
import Features from './Features/Features'
import { Join } from './Join'
import { TrustSignals } from './TrustSignals'
import WhatIs from './WhatIs/WhatIs'
import Steps from './Steps/Steps'
import { RobotShowcase } from './RobotShowcase'
import { useLanguage } from 'context/LanguageContext'

// Секции ниже первого экрана грузятся отдельными файлами: стартовый бандл
// легче, первый экран появляется быстрее.  Запрос уходит сразу при открытии
// страницы, так что к моменту прокрутки секции уже на месте.
const About = lazy(() => import('./About').then(m => ({ default: m.About })))
const RccToken = lazy(() =>
    import('./RccToken').then(m => ({ default: m.RccToken }))
)
const VideoDemonstration = lazy(() =>
    import('./VideoDemonstration').then(m => ({
        default: m.VideoDemonstration,
    }))
)
const LiveTrading = lazy(() =>
    import('./LiveTrading').then(m => ({ default: m.LiveTrading }))
)

/** Место под секцию, пока её файл едет, — страница не «прыгает». */
const sectionFallback = <div style={{ minHeight: 600 }} />

/** Главная страница проекта */
export const Main: React.FC = React.memo(() => {
    const { language } = useLanguage()
    const wrapperRef = useRef<HTMLDivElement>(null)

    useRevealOnScroll(wrapperRef)

    return (
        <div ref={wrapperRef}>
            <PageContent className={s.wrapper}>
                <Banner />

                {/* Доходность робота и калькулятор — сразу под первым экраном:
                    посетитель видит главное, не заходя в личный кабинет. */}
                <div data-reveal>
                    <RobotShowcase />
                </div>

                {/* Trust Signals — между Banner (hero) и WhatIs.  Сразу после
                    первого экрана посетитель получает доверительные сигналы:
                    статистика, security badges, отзывы.  Цель: снять основные
                    возражения «можно ли вам доверять / это работает / вы серьёзные». */}
                <div data-reveal>
                    <TrustSignals />
                </div>

                <div data-reveal>
                    <WhatIs />
                </div>

                <div data-reveal>
                    <Features />
                </div>

                <div data-reveal>
                    <Steps />
                </div>

                <div data-reveal>
                    <Suspense fallback={sectionFallback}>
                        <About />
                    </Suspense>
                </div>

                {/* ─── RCC token value section (Stage 23) ────────── */}
                <div data-reveal>
                    <Suspense fallback={sectionFallback}>
                        <RccToken />
                    </Suspense>
                </div>

                <div data-reveal>
                    <Suspense fallback={sectionFallback}>
                        <VideoDemonstration language={language} />
                    </Suspense>
                </div>

                <div data-reveal>
                    <Suspense fallback={sectionFallback}>
                        <LiveTrading />
                    </Suspense>
                </div>

                <div data-reveal>
                    <Join />
                </div>
            </PageContent>
        </div>
    )
})
